<template>
  <div>
    <List border size="small" style="width: 50%">
      <ListItem>
        <h4 v-if="this.customerId != 0">供应商详细信息</h4>
        <h4 v-if="this.customerId == 0">客户详细信息</h4>
      </ListItem>
      <ListItem style="width: 100%">
        <Row style="width: 100%">
          <Col span="5" class="title">名称:</Col>
          <Col>{{ info.supplierName }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title">地址:</Col>
          <Col span="">{{ info.supplierAddress }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title"> 状态:</Col>
          <Col span="">{{ state }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title">性质:</Col>
          <Col span="">{{
            info.supplierNature === 1 ? "厂家" : info.supplierNature === 2 ? "代理" : ""
          }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title"> 法人代表:</Col>
          <Col span="">{{ info.legalRepresentative }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title"> 联系电话:</Col>
          <Col span="">{{ info.phone }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title"> 注册资金(万元):</Col>
          <Col span="">{{ info.registeredCapital }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title" v-if="this.customerId == 0">客户规模:</Col>
          <Col span="5" class="title" v-if="this.customerId != 0">供应商规模:</Col>
          <Col span="">{{ info.supplierScale }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title"> 项目经理:</Col>
          <Col span="">{{ info.projectManager }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title">项目经理电话:</Col>
          <Col span="">{{ info.telephone }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title">驻场人员:</Col>
          <Col span="">{{ info.userName }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title">服务综合评分:</Col>
          <Col span="">{{ info.comprehensiveServiceRating }}</Col>
        </Row>
      </ListItem>
      <ListItem>
        <Row style="width: 100%">
          <Col span="5" class="title">创建时间:</Col>
          <Col span="">{{ info.createTime ? info.createTime.slice(0, 16) : "" }}</Col>
        </Row>
      </ListItem>
    </List>
  </div>
</template>
<script>
let id = window.localStorage.getItem("projectId");

let customerId = window.localStorage.getItem("customerId");
export default {
  data() {
    return {
      info: {},
      state: "",
      customerId: "",
    };
  },
  created() {
    let query = this.$route.query;
    this.customerId = customerId;
    if (query.info) {
      this.info = query.info;
      this.state =
        query.info.state == 1
          ? "提需求"
          : query.info.state == 2
          ? "需求沟通"
          : query.info.state == 3
          ? "正式立项"
          : query.info.state == 4
          ? "预算申报"
          : query.info.state == 5
          ? "上会通过"
          : query.info.state == 6
          ? "院内谈判"
          : query.info.state == 7
          ? "公开调研"
          : query.info.state == 8
          ? "招投标"
          : query.info.state == 9
          ? "签订合同"
          : query.info.state == 10
          ? "服务中"
          : query.info.state == 11
          ? "lost"
          : query.info.state == 12
          ? "潜在"
          : "";
    }
  },
  methods: {},
};
</script>
<style>
.title {
  font-weight: 600;
}
</style>
